export interface IDistributionLine {
  account: string
  debit: string
  credit: string
  description: string
  class: string
}

export interface IAccountTransaction {
  id: number
  accountNo: number
  date: string
  refNo: string
  type: AccountTransactionType
  payee: string
  account: number
  memo: string
  class: string
  location: string
  payment: number
  deposit: number
  balance?: number
  status: AccountTransactionStatus
  loanNumber?: number | null
  distributionLines?: IDistributionLine[]
  createdAt: Date
  updatedAt: Date
}

export enum AccountTransactionType {
  DEPOSIT = 'deposit',
  CHECK = 'check',
  JOURNAL_ENTRY = 'journalEntry',
  BILL_PAYMENT = 'billPayment',
  BILL = 'bill',
  EXPENSE = 'expense',
}

export const AccountTransactionTypeOptions = {
  [AccountTransactionType.DEPOSIT]: 'Deposit',
  [AccountTransactionType.CHECK]: 'Check',
  [AccountTransactionType.JOURNAL_ENTRY]: 'Journal Entry',
  [AccountTransactionType.BILL_PAYMENT]: 'Bill Payment',
  [AccountTransactionType.BILL]: 'Bill',
  [AccountTransactionType.EXPENSE]: 'Expense',
}

export enum AccountTransactionStatus {
  PENDING = 'pending',
  CHECKED = 'checked',
  RECONCILED = 'reconciled',
}

export const AccountTransactionStatusOptions = {
  [AccountTransactionStatus.PENDING]: '',
  [AccountTransactionStatus.CHECKED]: 'C',
  [AccountTransactionStatus.RECONCILED]: 'R',
}
